import { Theme, makeStyles, createStyles } from '@material-ui/core';
import { colors } from 'design-system';

const makeLandingStyles = makeStyles((theme: Theme) =>
  createStyles({
    landingContainer: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      marginTop: '13vh',
      flex: 1,
    },
    fontTitle: {
      fontSize: 24,
      lineHeight: '24px',
      fontWeight: 900,
    },
    fontSubtitle: {
      marginTop: 10,
      fontSize: 15,
      lineHeight: '22px',
      fontWeight: 400,
      letterSpacing: '.1px',
    },
    insurancesContainer: {
      marginTop: 10,
    },
    card: {
      width: 408,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      alignContent: 'flex-start',
      backgroundColor: 'transparent',
      padding: '28px 40px 40px 40px',
      borderRadius: 10,
      marginLeft: 20,
      marginRight: 20,
      marginTop: 30,
      transition: 'ease all 0.3s',

      '&:hover': {
        backgroundColor: colors.white,

        '& $cardSubtitle': {
          transition: 'ease all 0.3s',
          display: 'block',
        },

        '& $buttonFooter': {
          transition: 'ease all 0.3s',
          display: 'block',
        },
      },
    },
    cardTitle: {
      marginTop: 10,
      fontWeight: 900,
      fontSize: 23,
      lineHeight: '30px',
    },
    cardSubtitle: {
      display: 'none',
      marginTop: 10,
      fontWeight: 400,
      fontSize: 15,
      lineHeight: '22px',
      color: colors.abbey,
      transition: 'ease all 0.3s',
    },
    insuranceImage: {
      marginTop: 10,
      marginBottom: 10,
      height: 154,
    },
    footerContainer: {
      marginTop: 70,
    },
    footerDescription: {
      fontSize: '15px',
      lineHeight: '22px',
      fontWeight: 400,
    },
    buttonFooter: {
      display: 'none',
      marginTop: 10,
      height: 50,
      minWidth: 'max-content',
      borderRadius: 80,
      background: colors.bright_turquoise,
      color: 'white',
      paddingLeft: 30,
      paddingRight: 30,
      '&:hover': {
        background: 'white',
        color: colors.bright_turquoise,
      },
    },
    website: {
      color: colors.bright_turquoise,
      verticalAlign: 'bottom',
      fontWeight: 700,
    },
    mainContainer: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
    },
  }),
);

export default makeLandingStyles;
